import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useTheme } from '../Flowbite/ThemeContext';
export var DropdownItem = function DropdownItem(_ref) {
  var children = _ref.children,
    className = _ref.className,
    onClick = _ref.onClick,
    Icon = _ref.icon;
  var theme = useTheme().theme.dropdown.floating.item;
  return _jsxs("li", {
    className: classNames(theme.base, className),
    onClick: onClick,
    children: [Icon && _jsx(Icon, {
      className: theme.icon
    }), children]
  });
};